import React from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { TabScrollButtonProps } from '@mui/material/TabScrollButton';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const ArrowTabScrollButton = React.forwardRef<HTMLButtonElement, TabScrollButtonProps>(
  function ArrowTabScrollButton(props, ref) {
    const { direction, orientation = 'horizontal', disabled, onClick, className, ...rest } = props;

    const isVertical = orientation === 'vertical';

    const icon = isVertical
      ? (direction === 'left' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)
      : (direction === 'left' ? <ArrowLeftOutlined style={{ fontSize: 20 }} /> : <ArrowRightOutlined style={{ fontSize: 20 }} />);

    const ariaLabel = isVertical
      ? (direction === 'left' ? 'scroll up' : 'scroll down')
      : (direction === 'left' ? 'scroll left' : 'scroll right');

    return (
      <Button
        style={{ width: '100px', height: '100%', border: 'none', backgroundColor: 'transparent' }}
        icon={icon}
        ref={ref}
        className={className}
        disabled={disabled}
        onClick={onClick}
        aria-label={ariaLabel}
      />
    );
  }
);

export default ArrowTabScrollButton;
